// src/components/Navbar.js
import React from "react";
// import { Link } from 'react-router-dom';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import HeaderNav from "./headerNav";
const Navbar = () => {
  return (
    <>
      {/* Top contact bar */}
      <div className="bg-dark text-white py-2 px-3 border-bottom border-light border-opacity-25">
        <div className="container-fluid d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex gap-1 gap-md-4   align-items-center mb-2 mb-md-0">
            <span className="Topnav-para">
              <a
                href="tel:+96822842089"
                className="text-decoration-none text-white"
              >
                <FaPhoneAlt className="me-1 me-md-2 cursor-pointer" />
                +968 2284 2089
              </a>
            </span>

            <span className="Topnav-para ms-3">
              <a
                href="mailto:info@tig-oman.com"
                className="text-decoration-none text-white"
              >
                <FaEnvelope className="me-1 me-md-2 cursor-pointer" />
                info@tig-oman.com
              </a>
            </span>
          </div>
         <div className="d-flex gap-3 mt-1 mt-md-0 justify-content-end align-items-end">
  <a
    
   
    rel="noopener noreferrer"
    className="border border-white rounded-circle d-flex justify-content-center align-items-center text-white"
    style={{ width: 30, height: 30, cursor: "pointer" }}
  >
    <FaTwitter size={14} />
  </a>

  <a
    
    rel="noopener noreferrer"
    className="text-white border border-white rounded-circle d-flex justify-content-center align-items-center"
    style={{ width: 30, height: 30, cursor: "pointer" }}
  >
    <FaFacebook size={14} />
  </a>

  <a
    href="https://www.linkedin.com/company/towers-international-group/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-white border border-white rounded-circle d-flex justify-content-center align-items-center"
    style={{ width: 30, height: 30, cursor: "pointer" }}
  >
    <FaLinkedin size={14} />
  </a>

  <a
    
   
    rel="noopener noreferrer"
    className="text-white border border-white rounded-circle d-flex justify-content-center align-items-center"
    style={{ width: 30, height: 30, cursor: "pointer" }}
  >
    <FaInstagram size={14} />
  </a>

  <a
   
    rel="noopener noreferrer"
    className="text-white border border-white rounded-circle d-flex justify-content-center align-items-center"
    style={{ width: 30, height: 30, cursor: "pointer" }}
  >
    <FaYoutube size={14} />
  </a>
</div>

        </div>
      </div>
      <HeaderNav />
    </>
  );
};

export default Navbar;
